<template>
    <div
        class="widget-card-layout"
        :class="{ 'scroll-fixed': fixed }"
    >
        <div
            ref="content"
            class="widget-card-content"
        >
            <div class="content-top">
                <Icon
                    :icon="icon"
                    circle
                />
                <slot />
            </div>

            <div
                v-if="slots.bottom"
                class="page-bottom"
            >
                <slot name="bottom" />
            </div>
        </div>

        <div
            v-if="slots.actions"
            class="content-actions"
        >
            <slot name="actions" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, useSlots } from 'vue'
import Icon from 'widget-components/atoms/Icon/Icon.vue'
import useScrollShadow from 'widget-components/composables/scroll-shadow'

const slots = useSlots()

defineProps<{
    fixed?: boolean
    icon?: string | null
}>()

const content = ref<HTMLElement | null>(null)

onMounted(() => {
    useScrollShadow(content.value as HTMLElement)
})
</script>

<style lang="scss" scoped>
.widget-card-layout {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;

    &.scroll-fixed {
        max-height: 100vh;
    }
}
.widget-card-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 0 12px 18px 12px;

    .scroll-fixed & {
        overflow: hidden;
    }
}
.content-top {
    flex: 1
}

.content-actions {
    position: sticky;
    padding: 12px;
    padding-top: 0;
    bottom: 0;
    background: var(--color-white);
    box-shadow: 0px 0px 20px -10px darken(white, 50);
}
</style>
